import React from "react";
import "./style.css";
import {
  FaTwitter,
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa";
import { socialprofils } from "../../content_option";

export const Socialicons = (params) => {
  return (
    <div className="stick_follow_icon">
      <ul>
        {socialprofils.twitter && (
          <li>
            <a href={socialprofils.twitter} target="_blank" rel="noreferrer" >
              <FaTwitter />
            </a>
          </li>
        )}
        {socialprofils.facebook && (
          <li>
            <a href={socialprofils.facebook} target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>
          </li>
        )}
        {socialprofils.instagram && (
          <li>
            <a href={socialprofils.instagram} target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
          </li>
        )}
      </ul>
      <p>Seguime en mis redes</p>
    </div>
  );
};
